export default __webpack_public_path__ + "static/homeHeroTexture-5e1ea9db3726e0a49151da67be3f4427.png";